import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  container: {
    width: '60vw',
    position: 'sticky',
    top: 70,
  },
});
export default useStyles;
